export default function(form) {
  const formData = new FormData(form);
  const params = new URLSearchParams(formData);
  return params.toString();
}
